import type { CurvaDocument } from "./document";

/**
 * Clone a document for command execution with structural sharing of immutable
 * top-level collections (assets / styles) that commands rarely rewrite in place.
 *
 * Pages and scripts are cloned so in-place node / library mutations cannot
 * touch the store's live document. History error rollback should re-clone from
 * the store rather than eagerly snapshotting the working copy again.
 */
export function cloneDocumentForCommand(document: CurvaDocument): CurvaDocument {
  return {
    ...document,
    metadata: { ...document.metadata },
    viewport: document.viewport ? { ...document.viewport } : document.viewport,
    pages: structuredClone(document.pages),
    assets: document.assets,
    styles: document.styles,
    scripts: structuredClone(document.scripts ?? { items: [] }),
  };
}
